import {
	CHECK_AVAILABILITIES,
	CLEAR_QUOTATION,
	FETCH_FLIGHT_OPTIONS,
	INIT_ACCOMMODATIONS_PAGE_SIZE,
	PRE_BOOK,
	RESET_FLIGHTS_FILTER,
	RESET_FLIGHTS_PAGE_SIZE,
	RESTORE_BOOKING_SESSION,
	SAVE_QUOTATION_SEARCH_QUERY_STRING,
	SET_FLIGHTS_FILTER_BY,
	SET_FLIGHTS_SORT_BY,
	SHOW_MORE_FLIGHTS,
} from "app/actionTypes";
import env from "app/utils/env";
import axios from "app/utils/http/http";
import {
	SHOW_ALL_ACTIVITIES,
	SHOW_FLEX_RATES_MODAL,
	SHOW_MORE_ACCOMMODATIONS,
} from "app/pages/Booking/Quotation/quotationActionTypes";

export const clearQuotation = (data = {}) => {
	return {
		type: CLEAR_QUOTATION,
		...data,
	};
};

export const fetchFlightOptions = payload => {
	return {
		type: FETCH_FLIGHT_OPTIONS,
		promise: axios.post(`${env("QUOTE_API_URL")}/flightOptions`, payload, {
			headers: {
				"Content-type": "text/plain",
			},
		}),
	};
};

export const checkAvailibilities = quotationPayload => {
	// TODO a refacto pour ne plus passer par getStore().getState()
	// peut etre une fois que l'on aura plus redux-form sur la quote

	// @see https://perfectstay.atlassian.net/browse/FUX-21
	// On a besoin de passer le token uniquement pour savoir si un operateur est connecté ou non.
	// On effet, le token contiendra l'email de l'operator et le service de quote nous renverra l'email de l'operator

	return {
		type: CHECK_AVAILABILITIES,
		promise: axios.post(
			`${env("QUOTE_API_URL")}/quote`,
			{
				...quotationPayload,
			},
			{
				headers: {
					"Content-type": "application/json",
				},
			}
		),
	};
};

export const setFlightsSortBy = property => {
	return {
		type: SET_FLIGHTS_SORT_BY,
		sortBy: property,
	};
};

export const setFlightsFilterBy = properties => {
	return {
		type: SET_FLIGHTS_FILTER_BY,
		filterBy: properties,
	};
};

export const showMoreFlights = () => {
	return {
		type: SHOW_MORE_FLIGHTS,
	};
};

export const showAllActivities = () => {
	return {
		type: SHOW_ALL_ACTIVITIES,
	};
};

export const resetFlightsPageSize = () => {
	return {
		type: RESET_FLIGHTS_PAGE_SIZE,
	};
};

export const resetFlightsFilter = filtersValues => {
	return { type: RESET_FLIGHTS_FILTER, filtersValues };
};

export const preBook = data => {
	const isStopover = data?.bookingFlowId;

	let endpoint = env("QUOTE_API_URL");

	// @see mapFormToPayload in QuotationContainer
	if (isStopover) {
		endpoint = env("STOPOVER_API_URL");
	}

	return {
		type: PRE_BOOK,
		promise: axios.post(`${endpoint}/preBook`, data, {
			headers: {
				"Content-type": "text/plain",
			},
		}),
	};
};

export const restoreBookingSession = ({ bookingReference, email }) => {
	return {
		type: RESTORE_BOOKING_SESSION,
		promise: axios.post(
			`${env("QUOTE_API_URL")}/restoreBookingSession`,
			{ bookingReference, email },
			{
				headers: {
					"Content-type": "text/plain",
				},
			}
		),
	};
};

export const saveQuotationSearchQueryString = search => {
	return {
		type: SAVE_QUOTATION_SEARCH_QUERY_STRING,
		search,
	};
};

export const showMoreAccommodations = () => {
	return {
		type: SHOW_MORE_ACCOMMODATIONS,
	};
};

export const showFlexRatesModal = isFlexRatesModalOpened => {
	return {
		type: SHOW_FLEX_RATES_MODAL,
		isFlexRatesModalOpened,
	};
};

export const updateAccommodationsPageSize = accommodationsPageSize => {
	return {
		type: INIT_ACCOMMODATIONS_PAGE_SIZE,
		accommodationsPageSize,
	};
};
